import React, { useEffect, useState, useMemo, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import { Header } from '@backstage/core-components';
import 'ag-grid-enterprise';
import Loader from '../loader/Loader';
import { discoveryApiRef, useApi, fetchApiRef, identityApiRef } from '@backstage/core-plugin-api';
import '../NoteCustomstyle.css';
import axios from 'axios';

// Material UI
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const VirtualPrivateCloud = () => {
  const gridRef = useRef<any>(null);
  const containerStyle = useMemo(() => ({ width: "100%", height: "100vh" }), []);
  const gridStyle = useMemo(() => ({ height: 'calc(-200px + 80vh)', width: "100%", marginTop: '50px' }), []);
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [org, setOrg] = useState('');
  const [role, setRole] = useState('');
  const [tenantName, settenantName] = useState<string>(''); // for dropdown
  const [tenantsFromDb, setTenantsFromDb] = useState<any[]>([]);
  const [tenantId, setTenantId] = useState<string>('');
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const identityApi = useApi(identityApiRef)

  const fetchTenantsFromDb = async () => {
    try {
      const baseUrl = await discoveryApi.getBaseUrl('user');
      const response = await axios.get(`${baseUrl}/tenants`);
      return response.data;
    } catch (e) {
      console.error('Error fetching tenants:', e);
      return [];
    }
  };

  const fetchTenant = async () => {
    try {
      const details = await identityApi.getBackstageIdentity();
      const id = details.ownershipEntityRefs.find(ref =>
        ref.startsWith('tenantId:')
      )?.split(':')[1] || null;

      console.log("ID ---------", id)
      return id
    } catch (err) {
      console.error('Failed to get tenantId:', err);
    }
  }; 
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const baseUrl = await discoveryApi.getBaseUrl('user');

        let data: any[] = [];
        try {
          const fetchresponse = await fetchApi.fetch(`${baseUrl}/vpc`, {
            method: 'POST',
          });
          if (!fetchresponse.ok) {
            const errorText = await fetchresponse.text();
            throw new Error(`API error: ${fetchresponse.status} - ${errorText}`);
          }
          const response = await fetchresponse.json();
          // console.log('Fetched VPC data:', response);
          const tenantsFromDb = await fetchTenantsFromDb()
          setTenantsFromDb(tenantsFromDb);
          const id = await fetchTenant()
          console.log(`orgName:${id}`)
          const tenantOrgName = localStorage.getItem(`orgName:${id}`);
          console.log('tenantOrgName------',tenantOrgName)
          if (tenantOrgName) setOrg(tenantOrgName);
          //  Ensure role comes from API response
          setRole(response.role || '');

          data = response.data;
        } catch (error) {
          console.error('Fetch or JSON parse error:', error);
        }
        const formattedData = formatVpcData(data);
        const filterData = formattedData.filter(item => item.totalCost > 0);
         
        setRowData(filterData);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    
  }, []);

  const formatVpcData = (data: any[]) => {
    return data.map(item => {
      return {
        tenantName: item.tenantName,
        tenantId: item.tenantId, // 
        accountId: item.accountId,
        vpcId: item.vpcId,
        vpcName: item.vpcName,
        region: item.region,
        totalCost: item.totalCost,
        potentialSavings: item.potentialSavings,
        elasticIps: item.savingsBreakdown.elasticIps || 0,
        networkInterfaces: item.savingsBreakdown.networkInterfaces || 0,
      };
    });
  };

  //  Filter by tenantName
  const filteredData = tenantId
  ? rowData.filter(row => Number(row.tenantId) === tenantId)
  : rowData;

  //  Unique tenant IDs
  const tenants = [...new Set(rowData.map(r => r.tenantName))];

  const columnDefs = useMemo(() => {
    const baseCols = [
    { headerName: "Tenant Name", field: "tenantName", headerTooltip: "Tenant Name", rowGroup: true },
    { headerName: "Account Id", field: "accountId", headerTooltip: "Account Id", rowGroup: true },
    { headerName: "Name", field: "vpcName", headerTooltip: "Name" },
    { headerName: 'VPC ID', field: 'vpcId', headerTooltip: "VPC ID" },
    { headerName: 'Region', field: 'region', headerTooltip: "Region" },
    { headerName: 'Cost in $', field: 'totalCost', aggFunc: 'sum', headerTooltip:'Cost in $',valueFormatter: params => {
      const value = parseFloat(params.value);
      if (!isNaN(value))
        return value.toFixed(2);
    },},
    { headerName: 'Total Potential Cost Saving($)', field: 'potentialSavings', aggFunc: 'sum', headerTooltip:'Cost Cost in $',valueFormatter: params => {
      const value = parseFloat(params.value);
      if (!isNaN(value))
        return value.toFixed(2);
    },},
    // { headerName: 'Potential Cost Savings on Elastic Ips', field: 'elasticIps', aggFunc: 'sum', headerTooltip:'Cost in $',valueFormatter: params => {
    //   const value = parseFloat(params.value);
    //   if (!isNaN(value))
    //     return value.toFixed(2);
    // },},
    // { headerName: 'Potential Cost Savings on Network Interfaces', field: 'networkInterfaces', aggFunc: 'sum', headerTooltip:'Cost in $',valueFormatter: params => {
    //   const value = parseFloat(params.value);
    //   if (!isNaN(value))
    //     return value.toFixed(2);
    // },},
  
  ];
  
  return baseCols.map(col =>
    col.field === "tenantName"
      ? { ...col, hide: role != "SuperAdmin", rowGroup: role != "SuperAdmin" ? false : col.rowGroup }
      : col
  );
}, [role]);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1, filter: true, sortable: true, resizable: true, enableRowGroup: true, tooltipShowDelay: 0, tooltipInteraction: true, columnMenu: "new"
    };
  }, []);

  const autoGroupColumnDef = {
    minWidth: 250,
    cellRendererParams: {
      footerValueGetter: (params) => {
        const isRootLevel = params.node.level === -1;
        if (isRootLevel) {
          return "Total";
        }
        return "Sub Total";
      },
    },
  }

  const sideBar = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      }
    ],
    defaultToolPanel: '',
  }

  
  const gridOptions={
    suppressContextMenu: true
  }

  return (
    <div style={containerStyle}>
      <div>
        <Header title="Virtual Private Cloud" subtitle={`${org}`} />
      </div>

      {/*  Tenant Dropdown (only SuperAdmin can see) */}
      {role === "SuperAdmin" && (
        <div style={{ display: "flex", justifyContent: "flex-end", margin: "10px 0" }}>
          <FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
            <InputLabel></InputLabel>
            <Select
              value={tenantId}
              onChange={(e) => setTenantId(e.target.value)}
              displayEmpty
              MenuProps={{
                PaperProps: {
                  sx: {
                    // force vertical stacking
                    '& .MuiList-root': {
                      display: 'flex !important',
                      flexDirection: 'column !important',
                    },
                    // force left-aligned text inside items
                    '& .MuiMenuItem-root': {
                      justifyContent: 'flex-start',
                      pl: 2,
                    },
                  },
                },
              }}            >
              <MenuItem value="">All Tenants</MenuItem>
              {tenantsFromDb.map((tenant) => (
                <MenuItem key={tenant.id} value={tenant.id}>
                  {tenant.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      )}

      {loading ? (<Loader />) : (
        <div>
          <div className="ag-theme-quartz resourcecost" style={{ ...gridStyle, marginTop: 10 }}>
            <AgGridReact
              ref={gridRef}
              rowData={filteredData}
              columnDefs={columnDefs}
              autoGroupColumnDef={autoGroupColumnDef}
              rowGroupPanelShow={"always"}
              sideBar={sideBar}
              defaultColDef={defaultColDef}
              groupIncludeFooter={true}
              groupIncludeTotalFooter={true}
              groupDefaultExpanded={-1}
              suppressAggFuncInHeader={true}
              gridOptions={gridOptions}
            />
          </div>
          <div className="recommended-action-container">
            <div className="scroll-container">
              <strong>Recommended Action</strong>
              <ul>
                <li>
                  <strong>Streamlining VPC Resources for Cost Efficiency</strong>
                  <p>Efficient management of VPC resources can significantly reduce network-related costs.</p>
                  <ul>
                    <li>Consolidate NAT Gateways: Keep only one NAT Gateway per VPC to avoid unnecessary costs. Remove additional gateways if not required.</li>
                    <li>Release Unused Elastic IPs: Identify and release Elastic IPs that are not associated with running instances to prevent charges for idle IPs.</li>
                    <li>Review VPC Endpoints: Consolidate multiple VPC Endpoints to reduce costs. Delete any excess or unused endpoints.</li>
                    <li>Optimize Traffic Mirroring & Peering Connections: Assess the necessity of Traffic Mirroring sessions and Peering Connections. Remove any that are redundant or no longer needed.</li>
                  </ul>
                  <p>Considerations:</p>
                  <ul>
                    <li>Regularly monitor and adjust VPC configurations to maintain cost efficiency.</li>
                    <li>Ensure that changes do not affect essential services or performance.</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div className="note-container">
            <p>
              <strong>Note*</strong><span className="note-text">: Potential savings for VPCs are calculated by identifying and eliminating unnecessary costs from excess NAT Gateways, unused Elastic IPs, redundant VPC Endpoints, and VPC Peering Connections. It also accounts for savings from reducing Traffic Mirroring sessions and unattached Network Interfaces. The total potential savings are the sum of these reductions, ensuring they do not exceed the actual incurred VPC costs.</span>
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default VirtualPrivateCloud;
